import { createRequest } from "helpers/tools";

/**
 * Get attribution policy settings for a tracker
 * @param {string|number} trackerId - The tracker ID
 * @returns {Promise<Object>} Response with status, message, and data containing att_policy, only_attributed, and keywords
 */
export const getAttributionPolicy = async (trackerId) => {
    return await createRequest({
        suffix: `trackers/settings/${trackerId}/attribution-policy`,
        method: "get",
        handleError: false,
    });
};

/**
 * Update attribution policy settings for a tracker
 * @param {string|number} trackerId - The tracker ID
 * @param {Object} data - Attribution policy data
 * @param {boolean} data.only_attributed - If true, only landing page campaign signals are counted
 * @param {string} data.att_policy - Attribution policy: 'deny', 'approve', or 'anonymize' (always required)
 * @param {string[]} [data.keywords] - Keywords for landing page campaign detection (only when only_attributed is true)
 * @returns {Promise<Object>} Response with status and message
 */
export const updateAttributionPolicy = async (trackerId, data) => {
    const requestBody = {
        only_attributed: data.only_attributed,
        att_policy: data.att_policy,
    };

    if (data.only_attributed && data.keywords) {
        requestBody.keywords = data.keywords;
    }

    return await createRequest({
        suffix: `trackers/settings/${trackerId}/attribution-policy`,
        method: "post",
        payload: requestBody,
        handleError: false,
    });
};
